<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Permohonan Perkhidmatan">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id" @input="getDaerah(pencarian.lkp_negeri_id)" />
              <z-select style="margin:5px;" :items="daerah" class="mt4" label="Daerah"  v-model="pencarian.lkp_daerah_id" />
            </w-flex>
            <w-flex class="mt3">
              <z-select style="margin:5px; " v-model="pencarian.lkp_art_id" :items="lkp_art" label="Jenis Perkhidmatan" />
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis_id" label="ID Premis" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_status_id" :items="lkp_status" label="Status" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
  		  <z-table title="Senarai Permohonan Perkhidmatan" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
            <!-- <template #button v-if="$zutil.role('2') || $zutil.role('1') || $zutil.role('5')">
                <w-button dark class="green--bg ml1" :route="$route('art.permohonan.form',0)" >
                    <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
                </w-button>
            </template> -->
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
          <template #item-cell.tarikh_mohon="{ item, label, header, index }">
            <w-flex class="flex justify-center">
               {{$zutil.dateformat(item.tarikh_mohon)}} / {{$zutil.formatDateToTime(item.tarikh_mohon)}}
            </w-flex>
         </template>
         <template #item-cell.status="{ item, label, header, index }">
            <w-flex class="flex justify-left">
               <template v-if="item.ditukar==1">
                  Ditukar
               </template>
               <template v-else>
                  <template v-if="item.lkp_status_id ==21">
                     {{item.status}}<br>
                     Catatan : {{item.catatan}}
                  </template>
                  <template v-else>
                     {{item.status}}
                  </template>
               </template>
            </w-flex>
         </template>
       <template #item-cell.juruteknik = "{ item, label, header, index }">
       <w-flex   class                 = "flex justify-left">
       <template v-if                  = "item.lkp_art_id ==4">
                  {{item.juruteknik}}
               </template>
               <template v-else>
                  {{item.juruteknik}}
               </template>
            </w-flex>
         </template>
         <template #item-cell.premis="{ item, label, header, index }">
            <w-flex class="flex justify-left">
              <w-tooltip top color="primary">
                  <template #activator="{ on }">
                      <span v-on="on" class="ma3" @click="Buka(item)">
                       <u> {{item.premis}}</u>
                     </span>
                  </template>
                  Klik Detail
                </w-tooltip>
            </w-flex>
         </template>
          <template #item-cell.action="{ item, label, header, index }">
   <w-flex class="flex justify-center">

      <!-- button tindakan ai semulajadi -->
      <template v-if="item.lkp_art_id == 1 && item.ditukar == 0">
         
         <template v-if="$zutil.anyRole(['7', '9']) && item.lkp_status_id == 31 && item.juruteknik_id == $page.props.auth.user.id">
            <w-tooltip md top color="white" bg-color="black">
               <template #activator="{ on }">
                  <w-button class="mr2" v-on="on" bg-color="success" @click="TerimaAi(item)"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-check-circle</w-icon>
                  </w-button>
               </template>
               Terima
            </w-tooltip> &nbsp;
            <br>
            <w-tooltip md top color="white" bg-color="black">
               <template #activator="{ on }">
                  <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-times-circle</w-icon>
                  </w-button>
               </template>
               Tolak
            </w-tooltip> &nbsp;
            <br>
            <w-tooltip md top color="white" bg-color="black">
               <template #activator="{ on }">
                  <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                     <w-icon md class="mr2">fal fa-exchange</w-icon>
                  </w-button>
               </template>
               Tukar Juruteknik/Jurusuntik
            </w-tooltip> &nbsp;
           <br>
         </template>

         <w-tooltip md top align-left color="white" bg-color="black">
            <template #activator="{ on }">
               <w-button bg-color="info" v-on="on" v-if="$zutil.anyRole(['1', '2', '5']) && (item.lkp_status_id == 18 || item.lkp_status_id == 21)" :route="$route('art.permohonan.ai', 0) + '?salin=' + item.id" class="be fs-2"><div style="width: 8px"></div>
                  <w-icon md class="mr2">fal fa-copy</w-icon>
               </w-button>
            </template>
            Salin
         </w-tooltip>
         &nbsp;
         
         <w-tooltip top color="white" bg-color="black">
            <template #activator="{ on }">
               <w-button bg-color="warning" v-on="on" v-if="item.lkp_status_id == 19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('art.permohonan.ai', item.id)" class="be fs-2"><div style="width: 8px"></div>
                  <w-icon md class="mr2">fal fa-pencil</w-icon>
               </w-button>
            </template>
            Kemaskini
         </w-tooltip>
         &nbsp;

         <template v-if="$zutil.anyRole(['5']) && item.juruteknik_id == $page.props.auth.user.id">
            <template v-if="item.lkp_status_id != 21 && item.lkp_status_id != 18">
               <w-tooltip md top color="white" bg-color="black">
                  <template #activator="{ on }">
                     <inertia-link v-if="item.lkp_status_id != 21 && item.lkp_status_id != 18" :href="$route('art.semakan.ai-aiman', item.id)" v-on="on" class="w-button w-button--dark size--md warning-dark1--bg"><div style="width: 8px"></div> 
                        <w-icon md class="mr2">fal fa-pencil</w-icon>
                     </inertia-link>
                  </template>
                  Kemaskini
               </w-tooltip>
               &nbsp;
            </template>
            
            <w-tooltip md top align-right color="white" bg-color="black">
               <template #activator="{ on }">
                  <inertia-link :href="$route('art.semakan.ai', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                     <w-icon md class="mr2">fal fa-eye</w-icon>
                  </inertia-link>
               </template>
               Papar
            </w-tooltip>
            &nbsp;
         </template>
         
         <template v-else>
            <template v-if="$zutil.anyRole(['5']) && item.role_user == 5">
               <w-tooltip md top align-right color="white" bg-color="black">
                  <template #activator="{ on }">
                     <inertia-link :href="$route('art.semakan.ai', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                        <w-icon md class="mr2">fal fa-eye</w-icon>
                     </inertia-link>
                  </template>
                  Papar
               </w-tooltip>
            </template>
            
            <template v-else>
               <template v-if="$zutil.anyRole(['2', '7', '9']) && item.lkp_status_id == 39 || item.lkp_status_id == 40">
                  &nbsp;
                  <w-tooltip md top align-right color="white" bg-color="black">
                     <template #activator="{ on }">
                        <inertia-link :href="$route('art.semakan.ai', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> 
                           <div style="width: 8px"></div>
                           <w-icon md class="mr2">fal fa-eye</w-icon>
                        </inertia-link>
                     </template>
                     Papar
                  </w-tooltip>
               </template>
               
               <template v-else>
                  <template v-if="$zutil.anyRole(['7', '9'])">
                     <w-tooltip md top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <inertia-link :href="$route('art.semakan.ai-aiman', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                              <w-icon md class="mr2">fal fa-eye</w-icon>
                           </inertia-link>
                        </template>
                        Papar
                     </w-tooltip>
                  </template>

                  
                  <template v-else>
                     &nbsp;
                     <w-tooltip md top align-right color="white" bg-color="black">
                        <template #activator="{ on }">
                           <inertia-link :href="$route('art.semakan.ai', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> 
                              <div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-eye</w-icon>
                           </inertia-link>
                        </template>
                        Papar
                     </w-tooltip>
                  </template>
               </template>
            </template>
         </template>
      </template>


           <!-- button tindakan pd -->
               <template v-if="item.lkp_art_id ==2 ">
                  <template v-if="item.ditukar==0 && item.user_id != $page.props.auth.user.id ">
                     
                     <template v-if="!$zutil.anyRole(['2', '5']) && item.lkp_status_id==31">
                        
                        <!-- ROLE 4: BUTANG TERIMA TANPA anyCan -->
                        <template v-if="$zutil.anyRole(['4']) && item.lkp_status_id==31">
                           <w-tooltip md top color="white" bg-color="black" >
                              <template #activator="{ on }">
                                 <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, item.id)"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-check-circle</w-icon>
                                 </w-button>
                              </template>
                              Terima
                           </w-tooltip> &nbsp;
                           <br>
                           <w-tooltip md top color="white" bg-color="black" >
                              <template #activator="{ on }">
                                 <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-times-circle</w-icon>
                                 </w-button>
                              </template>
                              Tolak
                           </w-tooltip> &nbsp;
                           <br>
                           <w-tooltip md top color="white" bg-color="black" >
                              <template #activator="{ on }">
                                 <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-exchange</w-icon>
                                 </w-button>
                              </template>
                              Tukar Juruteknik/Jurusuntik
                           </w-tooltip> &nbsp;
                           <br>
                        </template>
                        
                        <template v-else-if="$zutil.anyCan(['4'])">
                        </template>
                        
                     </template>
                     
                     <w-tooltip md top align-left color="white" bg-color="black" >
                        <template #activator="{ on }">
                           <w-button bg-color="info" v-on="on" v-if=" $zutil.anyRole(['1', '2', '5','4']) && (item.lkp_status_id ==18||item.lkp_status_id ==21)" :route="$route('art.permohonan.pd',0)+'?salin='+item.id" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-copy</w-icon>
                           </w-button>
                        </template>
                        Salin
                     </w-tooltip>
                     &nbsp;
                     <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5','4'])" :route="$route('art.permohonan.pd',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                     &nbsp;

                     <template v-if="$zutil.anyRole(['5']) && item.juruteknik_id == $page.props.auth.user.id && item.lkp_art_id ==2">
                        
                        <template v-if="item.lkp_status_id != 21 && item.lkp_status_id != 18">
                           <w-tooltip md top color="white" bg-color="black">
                              <template #activator="{ on }">
                                 <inertia-link bg-color="warning" v-if="item.lkp_status_id !=21 && item.lkp_status_id !=18" :href="$route('art.semakan.pd-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md warning-dark1--bg"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-pencil</w-icon>
                                 </inertia-link>
                              </template>
                              Kemaskini
                           </w-tooltip>
                           &nbsp;
                        </template>
                        <w-tooltip md top align-right color="white" bg-color="black">
                           <template #activator="{ on }">
                              <inertia-link :href="$route('art.semakan.pd',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                 <w-icon md class="mr2">fal fa-eye</w-icon>
                              </inertia-link>
                           </template>
                           Papar
                        </w-tooltip>
                        &nbsp;
                     </template>
                     
                     <template v-else>
                        <template v-if="$zutil.anyRole(['1', '2', '5','4'])">
                           <template v-if="$zutil.anyRole(['4'])">
                              <!-- ROLE 4: PAPAR KE pd-aiman -->
                              <w-tooltip md top color="white" bg-color="black" v-if="$zutil.anyRole(['7', '8', '9', '10','4'])">
                                 <template #activator="{ on }">
                                    <inertia-link v-if="item.lkp_status_id!=21" :href="$route('art.semakan.pd-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                                       <w-icon md class="mr2">fal fa-eye</w-icon>
                                    </inertia-link>
                                 </template>
                                 Papar
                              </w-tooltip>
                              &nbsp;
                           </template>
                           <template v-else>
                              <w-tooltip md top color="white" bg-color="black" v-if="$zutil.anyRole(['7', '8', '9', '10','4'])">
                                 <template #activator="{ on }">
                                    <inertia-link v-if="item.lkp_status_id!=21" :href="$route('art.semakan.pd-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                                       <w-icon md class="mr2">fal fa-eye</w-icon>
                                    </inertia-link>
                                 </template>
                                 Papar
                              </w-tooltip>
                              <w-tooltip md top align-right color="white" bg-color="black" v-else>
                                 <template #activator="{ on }">
                                    <inertia-link :href="$route('art.semakan.pd',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                       <w-icon md class="mr2">fal fa-eye</w-icon>
                                    </inertia-link>
                                 </template>
                                 Papar 
                              </w-tooltip>
                           </template>
                        </template>
                        
                        <!-- BAHAGIAN UNTUK ROLE 7,8,9,10 - TAMBAH SYARAT juruteknik_id -->
                        <template v-else>
                           <!-- BUTANG TERIMA/TOLAK/TUKAR HANYA UNTUK JURUTEKNIK YANG DITUJU -->
                           <template v-if="item.lkp_status_id==31 && $zutil.anyRole(['7', '8', '9', '10','4']) && item.juruteknik_id == $page.props.auth.user.id">
                              <w-tooltip md top color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, item.id)"><div style="width: 8px"></div> 
                                       <w-icon md class="mr2">fal fa-check-circle</w-icon>
                                    </w-button>
                                 </template>
                                 Terima
                              </w-tooltip> &nbsp;
                              <br>
                              <w-tooltip md top color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                       <w-icon md class="mr2">fal fa-times-circle</w-icon>
                                    </w-button>
                                 </template>
                                 Tolak
                              </w-tooltip> &nbsp;
                              <br>
                              <w-tooltip md top color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                       <w-icon md class="mr2">fal fa-exchange</w-icon>
                                    </w-button>
                                 </template>
                                 Tukar Juruteknik/Jurusuntik
                              </w-tooltip> &nbsp;
                              <br>
                           </template>

                           <w-tooltip md top color="white" bg-color="black" v-if="$zutil.anyRole(['7', '8', '9', '10','4'])">
                              <template #activator="{ on }">
                                 <inertia-link v-if="item.lkp_status_id!=21" :href="$route('art.semakan.pd-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-eye</w-icon>
                                 </inertia-link>
                              </template>
                              Papar
                           </w-tooltip>
                           <w-tooltip md top align-right color="white" bg-color="black" v-else>
                              <template #activator="{ on }">
                                 <inertia-link :href="$route('art.semakan.pd',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-eye</w-icon>
                                 </inertia-link>
                              </template>
                              Papar
                           </w-tooltip>
                        </template>
                     </template>

                  </template>
                  
                  <template v-else-if="item.ditukar==0 && item.user_id == $page.props.auth.user.id ">
                     <template v-if="$zutil.anyRole(['7', '8', '9', '10']) && item.lkp_status_id==31 && item.juruteknik_id == $page.props.auth.user.id">
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, item.id)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-check-circle</w-icon>
                              </w-button>
                           </template>
                           Terima
                        </w-tooltip> &nbsp;
                        <br>
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-times-circle</w-icon>
                              </w-button>
                           </template>
                           Tolak
                        </w-tooltip> &nbsp;
                        <br>
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-exchange</w-icon>
                              </w-button>
                           </template>
                           Tukar Juruteknik/Jurusuntik
                        </w-tooltip> &nbsp;
                     </template>
                     
                     <template v-if="$zutil.anyRole(['2']) && item.lkp_status_id == 19">
                        <w-tooltip top color="white" bg-color="black">
                           <template #activator="{ on }">
                              <w-button bg-color="warning" v-on="on" v-if="item.juruteknik_id == $page.props.auth.user.id" :route="$route('art.semakan.pd-aiman',item.id)" class="be fs-2"><div style="width: 8px"></div>
                                 <w-icon md class="mr2">fal fa-pencil</w-icon>
                              </w-button>
                           </template>
                           Kemaskini
                        </w-tooltip>
                     </template>
                     &nbsp;
                     
                     <template v-if="item.juruteknik_id == $page.props.auth.user.id && $zutil.anyRole(['7', '8', '9', '10']) && (item.lkp_status_id == 44 || item.lkp_status_id==32)">
                        <w-tooltip md top color="white" bg-color="black">
                           <template #activator="{ on }">
                              <inertia-link :href="$route('art.semakan.pd-aiman', item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-eye</w-icon>
                              </inertia-link>
                           </template>
                           Papar
                        </w-tooltip>
                     </template>
                     <template v-else>
                     <w-tooltip md top align-right color="white" bg-color="black">
                        <template #activator="{ on }">
                           <inertia-link :href="$route('art.semakan.pd',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-eye</w-icon>
                           </inertia-link>
                        </template>
                        Papar
                     </w-tooltip>
                     </template>
                  </template>
               </template>
                 

                  <template v-if="item.lkp_art_id ==3 && item.ditukar==0">               
                     <template v-if="$zutil.anyRole(['8', '10']) && item.lkp_status_id==31">
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                             <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, item.id)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-check-circle</w-icon>
                             </w-button>
                           </template>
                           Terima
                        </w-tooltip> &nbsp;
                        <br>
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                             <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-times-circle</w-icon>
                             </w-button>
                           </template>
                           Tolak
                        </w-tooltip> &nbsp;
                        <br>
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-exchange</w-icon>
                              </w-button>
                           </template>
                           Tukar Juruteknik/Jurusuntik
                        </w-tooltip> &nbsp;
                       <br>
                     </template>
                     <w-tooltip md top align-left color="white" bg-color="black" >
                        <template #activator="{ on }">
                           <w-button  bg-color="info" v-on="on"  v-if=" $zutil.anyRole(['1', '2', '5']) && (item.lkp_status_id ==18||item.lkp_status_id ==21)" :route="$route('art.permohonan.et',0)+'?salin='+item.id" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-copy</w-icon>
                           </w-button>
                        </template>
                        Salin
                     </w-tooltip>
                     &nbsp;
                     <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('art.permohonan.et',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                     &nbsp;
                     <w-tooltip md top color="white" bg-color="black" v-if="$zutil.anyRole(['8', '10'])">
                         <template #activator="{ on }">
                             <inertia-link v-if="item.lkp_status_id!=21" :href="$route('art.semakan.et-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                               <w-icon md class="mr2">fal fa-eye</w-icon>
                             </inertia-link>
                         </template>
                        Papar
                     </w-tooltip>
                     <w-tooltip md top align-right color="white" bg-color="black" v-else>
                        <template #activator="{ on }">
                           <inertia-link :href="$route('art.semakan.et',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                           <w-icon md class="mr2">fal fa-eye</w-icon>
                        </inertia-link>
                        </template>
                        Papar
                     </w-tooltip>
                  </template>
                  <template v-if="item.lkp_art_id ==4 && item.ditukar==0">
                     <template v-if="$zutil.anyRole(['4']) && item.lkp_status_id==31">
                        <template v-if="$zutil.anyCan(['3'])">
                        <w-tooltip md top color="white" bg-color="black">
                           <template #activator="{ on }">
                             <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, item.id)"><div style="width: 8px"></div> 
                              <w-icon md class="mr2">fal fa-check-circle</w-icon>
                             </w-button>
                           </template>
                           Terima
                        </w-tooltip> &nbsp;
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                             <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-times-circle</w-icon>
                             </w-button>
                           </template>
                           Tolak
                        </w-tooltip> &nbsp;
                        <br>
                        <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-exchange</w-icon>
                              </w-button>
                           </template>
                           Terima & Pilih Juruteknik/Jurusuntik
                        </w-tooltip> &nbsp;
                        <br>
                        </template>
                        <template v-else-if="$zutil.anyCan(['4'])">

                        </template>
                     </template>
                     <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('art.permohonan.sinkronisasi',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-eye</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                     &nbsp;
                     <template v-if="$zutil.anyRole(['4']) && item.role_user == 4">
                           <template v-if="$zutil.anyCan(['3'])">
                              <w-tooltip md top color="white" bg-color="black">
                                    <template #activator="{ on }">
                                       <inertia-link v-if="item.lkp_status_id!=21" :href="$route('art.semakan.sinkronisasi-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                                          <w-icon md class="mr2">fal fa-pencil</w-icon>
                                       </inertia-link>
                                    </template>
                                    Kemaskini
                                 </w-tooltip>
                                 &nbsp;
                                 <w-tooltip md top align-right color="white" bg-color="black" >
                                 <template #activator="{ on }">
                                    <inertia-link :href="$route('art.semakan.sinkronisasi',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-eye</w-icon>
                                 </inertia-link>
                                 </template>
                                 Papar 
                              </w-tooltip>
                           </template>
                           <template v-else-if="$zutil.anyCan(['4'])">

                           </template>
                        </template>
                        <template v-else>

                           <w-tooltip md top color="white" bg-color="black" v-if="$zutil.anyRole(['4','7', '9']) && item.juruteknik_id == $page.props.auth.user.id">
                              <template #activator="{ on }">
                                 <inertia-link v-if="item.lkp_status_id!=21" :href="$route('art.semakan.sinkronisasi-aiman',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 8px"></div> 
                                     <w-icon md class="mr2">fal fa-eye</w-icon>
                                 </inertia-link>
                              </template>
                               Papar
                           </w-tooltip>
                           <w-tooltip md top align-right color="white" bg-color="black" v-else>
                              <template #activator="{ on }">
                                 <inertia-link :href="$route('art.semakan.sinkronisasi',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                                    <w-icon md class="mr2">fal fa-eye</w-icon>
                                 </inertia-link>
                              </template>
                              Papar                     
                           </w-tooltip>
                        </template>

                  </template>
                <template  v-if = "item.lkp_art_id == 5 && item.ditukar==0">
                <w-tooltip md top align-left color = "white" bg-color = "black" >
                <template  #activator = "{ on }">
               <w-button  bg-color = "info" v-on = "on"  v-if = "item.lkp_status_id !=18 && item.lkp_status_id == 21 && $zutil.anyRole(['1', '2', '5'])" :route = "$route('art.permohonan.bse',0)+'?salin='+item.id" class = "be fs-2"><div style = "width: 8px"></div>
                <w-icon    md class = "mr2">fal fa-copy</w-icon>
                  </w-button>
                </template>
                Salin
              </w-tooltip>
                &nbsp;
                     <template v-if="item.lkp_status_id==31 && $zutil.anyRole(['4'])">
                        <template v-if="$zutil.anyCan(['3'])">
                           <w-tooltip md top color="white" bg-color="black" >
                              <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="success" @click="add(item, 1)"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-check-circle</w-icon>
                              </w-button>
                              </template>
                              Terima
                           </w-tooltip> &nbsp;
                           <w-tooltip md top color="white" bg-color="black" >
                              <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-times-circle</w-icon>
                              </w-button>
                              </template>
                              Tolak
                           </w-tooltip> &nbsp;
                        </template>
                        <template v-else-if="$zutil.anyCan(['4'])">

                        </template>
                     <!-- <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-exchange</w-icon>
                              </w-button>
                           </template>
                           Tukar Juruteknik/Jurusuntik
                        </w-tooltip> &nbsp; -->
                  </template>
                     <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('art.permohonan.bse',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                     &nbsp;
                     <w-tooltip md top align-right color="white" bg-color="black" >
                        <template #activator="{ on }">
                           <inertia-link :href="$route('art.semakan.bse',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                           <w-icon md class="mr2">fal fa-eye</w-icon>
                        </inertia-link>
                        </template>
                        Papar
                     </w-tooltip>
                  </template>
                  <template v-if = "item.lkp_art_id ==6 && item.ditukar==0">
                     <w-tooltip md top align-left color = "white" bg-color = "black" >
                        <template  #activator = "{ on }">
                        <w-button  bg-color = "info" v-on = "on"  v-if = "item.lkp_status_id !=18 && item.lkp_status_id == 21 && $zutil.anyRole(['1', '2', '5'])" :route = "$route('art.permohonan.ferteliti',0)+'?salin='+item.id" class = "be fs-2"><div style = "width: 8px"></div>
                        <w-icon    md class = "mr2">fal fa-copy</w-icon>
                           </w-button>
                        </template>
                        Salin
                     </w-tooltip>
                &nbsp;
                     <template v-if="$zutil.anyRole(['4']) && item.lkp_status_id==31">
                        <template v-if="$zutil.anyCan(['3'])">
                           <w-tooltip md top color="white" bg-color="black">
                              <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="success" @click="add(item,1
                              )"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-check-circle</w-icon>
                              </w-button>
                              </template>
                              Terima
                           </w-tooltip> &nbsp;
                           <w-tooltip md top color="white" bg-color="black" >
                              <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="error" @click="DTindakan(item, 2)"><div style="width: 8px"></div> 
                                    <w-icon md class="mr2">fal fa-times-circle</w-icon>
                              </w-button>
                              </template>
                              Tolak
                           </w-tooltip> &nbsp;
                           <br>
                        </template>
                        <template v-else-if="$zutil.anyCan(['4'])">

                        </template>
                        <!-- <w-tooltip md top color="white" bg-color="black" >
                           <template #activator="{ on }">
                              <w-button class="mr2" v-on="on" bg-color="warning" @click="DTindakan(item, 3)"><div style="width: 8px"></div> 
                                 <w-icon md class="mr2">fal fa-exchange</w-icon>
                              </w-button>
                           </template>
                           Terima & Pilih Juruteknik/Jurusuntik
                        </w-tooltip> &nbsp; -->
                       <!-- <br> -->
                     </template>
                     <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on" v-if="item.lkp_status_id ==19 && $zutil.anyRole(['1', '2', '5'])" :route="$route('art.permohonan.ferteliti',item.id)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                     &nbsp;
                     <w-tooltip md top align-right color="white" bg-color="black">
                        <template #activator="{ on }">
                           <inertia-link :href="$route('art.semakan.ferteliti',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                           <w-icon md class="mr2">fal fa-eye</w-icon>
                        </inertia-link>
                        </template>
                        Papar
                     </w-tooltip>
                  </template>
               &nbsp;
               <w-tooltip md top color="white" bg-color="black" v-if="item.lkp_status_id == 19">
                  <template #activator="{ on }">
                     <w-button class="ma1" v-on="on" bg-color="error-dark1" @click="destroy1(item.id)"><div style="width: 4px"></div> 
                        <w-icon class="mr1" md style="color: white;">fal fa-trash</w-icon>
                     </w-button>
                  </template>
                  Padam
               </w-tooltip>
  		      </w-flex>
  		    </template>
  		  </z-table>
      </div>
         <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            width="900"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>              
               <template v-if="dialog_form.tindakan == 3 && dialog_form.lkp_art_id == 4">
                  <w-icon class="mr2">fal fa-exchange</w-icon>
                  Terima & Pilih Juruteknik/Jurusuntik
               </template>
               <template v-else-if="dialog_form.tindakan == 3">
                  <w-icon class="mr2">fal fa-exchange</w-icon>
                  Tukar Juruteknik/Jurusuntik
               </template>
               <template v-else>
                  <w-icon class="mr2">fal fa-times-circle</w-icon>
                  Tolak
               </template>
            </template>
            <template v-if="dialog_form.tindakan == 3">
               <div class="w-flex wrap smd-column" >
               <div class="grow " style="line-height: 35px">
                  <table >
                     <tbody>
                     <tr class="row_data">
                        <td><b>TARIKH / MASA MOHON</b></td>
                        <td><b> : </b></td>
                        <td>{{dialog_form.tarikh_mohon}}</td>
                     </tr>
                     <tr class="row_data">
                        <td><b>NO. PERMOHONAN</b></td>
                        <td><b> : </b></td>
                        <td>{{dialog_form.no_permohonan}}</td>
                     </tr>
                     </tbody>
                  </table>
                 </div>
                 <div class="mx2"></div>
                 <div class="grow " style="line-height: 35px">
                  <table >
                     <tbody>
                     <tr class="row_data">
                        <td><b>PENTERNAK / NO TELEFON</b></td>
                        <td><b> : </b></td>
                        <td>{{dialog_form.nama_premis}} / {{dialog_form.no_tel_premis}}</td>
                     </tr>
                     <tr class="row_data">
                        <td><b>ID PREMIS / NAMA PREMIS</b></td>
                        <td><b> : </b></td>
                        <td>{{dialog_form.premis}}</td>
                     </tr>
                     </tbody>
                  </table>
               </div>
               </div>
            </template>
            <w-form 
               ref="form" 
               v-model="dialog.valid"
               @validate="tukarJuruteknik(dialog_form, dialog_form.id)"
               @success="success"
               >
               <template v-if="dialog_form.tindakan == 3">
                  <z-select class="mt4" outline :items="juruteknik_list_tukar" label="Nama Juruteknik/Jurusuntik *"  v-model="dialog_form.juruteknik_id"  :validators="[validators.required]"/>
               </template>
               <w-textarea class="mt4" label="Catatan *" v-model="dialog_form.catatan" :validators="[validators.required]" outline />
            </w-form>
            <template #actions>
               <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
               <w-button 
               class="ml1" 
               :loading="dialog.loading"
               :disabled="dialog.valid === false"
               @click="$refs.form.validate()"
               >
                 SIMPAN
               </w-button>
            </template>
         </w-dialog>
         <w-dialog
            v-model="dialog1.show"
            :fullscreen="dialog1.fullscreen"
            width="650"
            :persistent="dialog1.persistent"
            :persistent-no-animation="dialog1.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
              <w-icon class="mr2">fal fa-cog</w-icon>
              {{dialog1.title}}
            </template>
             <w-form ref="form" 
               v-model:errors-count="form.errorsCount"
               v-model="dialog1.valid"
               @validate="simpan(form , form.id, 1)"
               @success="success" 
               >
         
                <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                    <w-flex wrap :gap="2">
                       <div class="grow mb4" style="min-width: 200px">
                          <w-input class="mt4" outline label="Tarikh Temu Janji Penilaian *" type="date" v-model="form.tarikh_temujanji" :validators="[validators.required]"/>
                          <w-select class="mt4" outline :items="penilai" label="Nama Pegawai Penilaian *"  v-model="form.penilai_id" multiple :validators="[validators.required]"/>
                        </div>
                    </w-flex>
                 </div>
              </div>
           </w-form>
            <template #actions>
              <div class="spacer" />
              <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog1.show = false">TUTUP</w-button>
               <w-button 
                  class="ml1" 
                  :loading="dialog1.loading"
                  v-if="dialog1.loading===false"
                  :disabled="dialog1.valid === false"
                  @click="$refs.form.validate()"
                  >

                    SIMPAN
                  </w-button>
                  <w-button 
                  class="ml1" 
                  :loading="dialog1.loading"
                  v-if="dialog1.loading===true"
                  disabled
                  @click="$refs.form.validate()"
                  >
                    SIMPAN
                  </w-button>
           </template>
         </w-dialog>
         <w-dialog
            v-model="dialog2.show"
            :fullscreen="dialog2.fullscreen"
            width="700"
            :persistent="dialog2.persistent"
            :persistent-no-animation="dialog2.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>              
              MAKLUMAT PREMIS
            </template>
            <div class="w-flex wrap smd-column" >
               <div class="grow " style="line-height: 35px">
                  <table >
                     <tbody>
                     <tr class="row_data">
                        <td valign="top"><b>NAMA PENTERNAK</b></td>
                        <td valign="top"><b> &nbsp; : &nbsp; </b></td>
                        <td> {{dialog_form1.nama_peternak}}</td>
                     </tr>
                     <tr class="row_data">
                        <td valign="top"><b>ID / NAMA PREMIS</b></td>
                        <td valign="top"><b> &nbsp; : &nbsp; </b></td>
                        <td>{{dialog_form1.premis}}</td>
                     </tr>
                     <tr class="row_data">
                        <td valign="top"><b>ALAMAT</b></td>
                        <td valign="top"><b> &nbsp; : &nbsp; </b></td>
                        <td> {{dialog_form1.alamat_peternak}}, {{dialog_form1.poskod_peternak}}, {{dialog_form1.daerah_peternak}}, {{dialog_form1.negeri_peternak}}</td>
                     </tr>
                     <tr class="row_data">
                        <td valign="top"><b>NO TEL PREMIS</b></td>
                        <td valign="top"><b> &nbsp; : &nbsp; </b></td>
                        <td> {{dialog_form1.no_tel_premis}}</td>
                     </tr>
                     </tbody>
                  </table>
                 </div>
              </div>
            <template #actions>
              <div class="spacer" />
              <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog2.show = false">TUTUP</w-button>
               
           </template>
         </w-dialog>

         <w-dialog
            v-model="dialog3.show"
            :fullscreen="dialog3.fullscreen"
            width="700"
            :persistent="dialog3.persistent"
            :persistent-no-animation="dialog3.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>              
              MAKLUMAT TERIMAAN
            </template>

              <table class="w-table" color="light"  width="100%" style="border:none;">
                      <thead>
                        <tr>
                          <td class="w-table__header  text-left" width="1%" style="border:none;" >
                           Berikut ialah senarai semen yang dimohon oleh penternak:<br><br>
                           Ringkasan Semen Dimohon:
                          </td>
                        </tr>
                      </thead>
                   </table>
                   <br>

                  <div class="w-table-wrap" style="max-height: 400px;">
                  <div class="table-profil-scrol">
                    <table class="w-table" color="light" >
                      <thead>
                        <tr>
                          <th class="w-table__header  text-center" width="1%">BIL</th>
                          <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                          <th class="w-table__header  text-center">BAKA TERNAKAN</th>
                          <th class="w-table__header  text-center">JENIS SEMEN</th>
                        </tr>
                      </thead>
                      
                      <tbody>
                        <template v-if="dialog_form_terima.ternakan_art.length == 0">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="9"> Tiada Data.</td>
                          </tr>
                        </template>
                        <template v-for="(dt, ind) in dialog_form_terima.ternakan_art">
                          <tr class="w-table__row" >
                            <td class="w-table__cell text-center" >{{ind+1}}</td>
                            <td class="w-table__cell text-center" >{{dt.id_ternakan}} | {{dt.nama_ternakan}}</td>
                            <td class="w-table__cell text-center" >{{dt.baka_ternakan}} </td>
                            <td class="w-table__cell text-center" >{{dt.jenis_semen}} </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                   <br>
                   <br>

                     <table class="w-table" color="light"  width="100%" style="border:none;">
                      <thead>
                        <tr>
                          <td class="w-table__header  text-left" width="1%" style="border:none;" >
                           Adakah anda ingin meneruskan dan menerima permohonan ini?
                          </td>
                        </tr>
                      </thead>
                   </table>
                   <br>

                 </div>
              </div>
            <template #actions>
              <div class="spacer" align="center" />
              <w-button class="mr2" v-on="on" bg-color="success" @click="onSuccess(1, dialog_form_terima.id)">Ya
               </w-button>
               &nbsp;
              <w-button bg-color="grey-light5--bg" @click="dialog3.show = false">Tidak</w-button>
               
           </template>
         </w-dialog>

	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan Pembiakan', route: '/art' },
        // { label: 'Permohonan ART', route: '/art/permohonan' },
      ],
      title : 'Art Permohonan',
      form : this.d_form,
      

      pencarian: {
         premis_id: '',
         lkp_art_id: '',
         lkp_status_id: '',
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_daerah_id: '',
      },
      premis: [],
      premis_id: [],
      lkp_art: [],
      lkp_status :[],
      juruteknik_list: [],
      juruteknik_list_tukar : [],
      tarikh: [],
      lkp_status :[],
      penilai:[],
      negeri:[],
      bandar:[],
      daerah:[],
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      dialog1: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      dialog2: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      dialog3: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 1800,
          item: {name: '', email: '', mobile: ''}
      },
      

    }
  },
  methods: {
    Buka(item){
      this.dialog_form1 = {
            premis : item.premis,
            no_tel_premis : item.no_tel_premis,
            nama_peternak : item.nama_peternak,
            alamat_peternak : item.alamat_peternak,
            poskod_peternak : item.poskod_peternak,
            daerah_peternak : item.daerah_peternak,
            negeri_peternak : item.negeri_peternak,
        }
       this.dialog2.show = true;
    },
   DTindakan(item, tindakan){
      //tindakan '3' untuk tukar juruteknik
      //tindakan '2' untuk Padam
       this.dialog_form = {
           id : item.id,
           juruteknik_id : item.juruteknik_id,
           catatan : null,
           tindakan : tindakan,
           tarikh_mohon : item.tarikh_mohon,
           no_permohonan : item.no_permohonan,
           nama_premis : item.nama_premis,
           no_tel_premis : item.no_tel_premis,
           nama_pemohon : item.nama_pemohon,
           no_tel_pemohon : item.no_tel_pemohon,
           premis : item.premis,
           lkp_art_id : item.lkp_art_id,
       }
       // this.getJuruteknik(item)
       this.getJuruteknikTukar(item)
       this.dialog.show = true;
   },

   TerimaAi(item){
      this.dialog_form_terima = {
            id : item.id,
            ternakan_art: item.ternakan_art,
        }
       this.dialog3.show = true;
    },

   add(item, tindakan){
          this.form = {
              id : item.id,
              penilai_id : item.penilai_id,
              tarikh_temujanji : item.tarikh_temujanji,
              tindakan : tindakan,

          }
          
          this.getPenilai(item)
          this.dialog1.show = true
          this.dialog1.title = 'Tarikh Temu Janji Penilaian '
          this.form.saveButton = "Simpan"
      },

   getJuruteknik(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !='' ){
         if(data.lkp_art_id ==4){// sinkronisasi(stt negri) pilih juruteknik
            var lkp_art_id = 4;
            var lkp_berahi_id = 2; // untuk sinkron get juruteknik dr.veterinar
         }else{
            var lkp_art_id =data.lkp_art_id;
            var lkp_berahi_id = 0;
         }
        this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+data.lkp_negeri_id+'/'+lkp_art_id+'/'+lkp_berahi_id, {}).then(res => {
          this.juruteknik_list = res
        })
      }
   },

   getJuruteknikTukar(data){
      if(data.lkp_negeri_id !='' && data.lkp_art_id !='' ){
         if(data.lkp_art_id ==4){// sinkronisasi(stt negri) pilih juruteknik
            var lkp_art_id = 4;
            var lkp_berahi_id = 2; // untuk sinkron get juruteknik dr.veterinar
         }else{
            var lkp_art_id =data.lkp_art_id;
            var lkp_berahi_id = 0;
         }
        this.$zcomm.get(this.api_service + 'lookup/juruteknik_tukar/'+data.lkp_negeri_id+'/'+data.lkp_art_id+'/'+data.juruteknik_id+'/'+lkp_berahi_id, {}).then(res => {
          this.juruteknik_list_tukar = res
        })
      }
    },
   getPenilai(data){
         this.$zcomm.get(this.api_service + 'lookup/penilai', {lkp_negeri_id:data.lkp_negeri_id}).then(res => {
           this.penilai = res
         })
       },



   simpan(form, id, tindakan){
         this.dialog1.loading = true
         if(this.dialog1.valid == true){
            if (id > 0) 
            {
              form.terima = 1
              this.$zcomm.update('art.semakan.tindakan', id, form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.dialog1.show = false;
                this.$inertia.visit(this.$route('art.semakan.index'));
              })
            }
            
         }else{
            this.dialog1.loading = false
         }
       },



   tukarJuruteknik(tindakan, art_id){
      if(tindakan.catatan != null){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (art_id > 0){
              this.$zcomm.update('art.semakan.tindakan', art_id, tindakan)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan.tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else if (tindakan.tindakan==3) {
                    this.$zutil.notify("Berjaya ditukar", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.dialog.show = false;
                this.$inertia.visit(this.$route('art.semakan.index'));
              })
            }
          }
        })
      // }else if(tindakan.lkp_art_id == 4){
      //   this.$swal({
      //     title: 'Anda Pasti?',
      //     // text: "Are you sure want to delete this item!",
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Ya',
      //     cancelButtonText: 'Tidak'
      //   }).then((result) => {
      //     if (result.value) {
      //       if (art_id > 0){
      //         this.$zcomm.update('art.semakan.tindakan', art_id, tindakan)
      //         .then(res => {
      //           if (typeof this.onAfterEdit === "function") {
      //             this.onAfterEdit()
      //           }
      //           if (tindakan.tindakan==1) {
      //               this.$zutil.notify("Berjaya disimpan", true);
      //           }else if (tindakan.tindakan==3) {
      //               this.$zutil.notify("Berjaya ditukar", true);
      //           }else{
      //             this.$zutil.notify("Berjaya ditolak", false);
      //           }
      //           this.dialog.show = false;
      //           this.$inertia.visit(this.$route('art.semakan.index'));
      //         })
      //       }
      //     }
      //   })
      }else{
        this.$zutil.notify("Catatan Wajib Diisi", false);
      }
      
    },

    onSuccess(tindakan, art_id){
      this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (art_id > 0){
              this.$zcomm.update('art.semakan.tindakan', art_id, {tindakan :tindakan})
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                if (tindakan==1) {
                    this.$zutil.notify("Berjaya disimpan", true);
                }else{
                  this.$zutil.notify("Berjaya ditolak", false);
                }
                this.dialog.show = false;
                this.$inertia.visit(this.$route('art.semakan.index'));
              })
            }
          }
        })
      
    },
   destroy1(id){
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })
   },

   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       params.per_page =9999;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {
        this.lkp_status = res
      })
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },

   getNegeri() {
     this.$zcomm.get(this.api_service + 'lookup/negeri_user', {}).then(res => {
       this.negeri = res

       // kalau hanya ada 1 negeri (role 4), langsung set default
       if (this.negeri.length === 1) {
         this.selectedNegeri = this.negeri[0].value
         this.getDaerah(this.selectedNegeri)
       }
     })
   },


   getBandar(i){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+i, {}).then(res => {
          this.bandar = res
        })
      },

   getDaerah(i){
        this.$zcomm.get(this.api_service + 'lookup/daerah/'+i, {}).then(res => {
          this.daerah = res
        })
      },

   getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res
      })
    },
    
  
  },

  watch: {

  },
  mounted() {
   this.getStatus();
   this.getPremis();
   this.getNegeri();
   // this.getPenilai();
   this.getPremisCarian();
   this.getArt();
    // override default setting
    this.dialog.width = 500
    this.dialog1.width = 500
      
  },
}
</script>
